(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beardsman-soap-shop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.soap-shop').forEach((shop) => {
    let sibling = shop.closest('.shopify-section')?.nextElementSibling;
    while (sibling) {
      const duplicateHeading = sibling.querySelector('h1');
      if (duplicateHeading) {
        duplicateHeading.remove();
        break;
      }
      sibling = sibling.nextElementSibling;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
